window.addEventListener("load", (e) => {
  document.querySelectorAll(".block-employee_carousel").forEach((carousel) => {
    const blockId = carousel.dataset.id;
    const swiper = new Swiper("#slider-" + blockId + "", {
      autoplay: {
        delay: 8000,
      },
      speed: 1000,
      // centeredSlides: true,
      keyboard: {
        enabled: true,
      },
      grabCursor: true,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 50,
      navigation: {
        nextEl: ".posts-button-next-" + blockId + "",
        prevEl: ".posts-button-prev-" + blockId + "",
      },
      breakpoints: {
        576: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
        992: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
      },
    });
  });
});
